module.exports = __webpack_public_path__ + "static/media/YF56_4.80fec952.jpg";